import './_jquery-global'
import 'popper.js'
import 'bootstrap'
import 'perfect-scrollbar'
import './vendor/jquery.elevateZoom-3.0.8.min'
import 'lazyload'
import './_panel-menu'
import 'slick-carousel'
import 'jquery.cookie'
import './_wookie'

import './_products'

import './_recharge-overrides'
import './_mailchimp-form'

$(function() {
  var ga = window.ga,
      $cartNoteTextarea = $('textarea#note')

  // Get discount code passed as a url parameter and stores it as a cookie
  var urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has('discount')) {
    $.cookie('discount_code', urlParams.get('discount'), { path: '/' })
  }

  // Check for url passing 'discount_pct' param - usually from an ad.
  if (urlParams.has('pct')) {
    var $modalDiscount = $('#modalDiscount')
    $modalDiscount.find('#modal-discount-percentage').html(urlParams.get('pct'))
    $modalDiscount.modal('toggle')
  }

  // Check for url passing 'discount_pct' param - usually from an ad.
  if (urlParams.has('pct_eml')) {
    var $modalDiscountEmail = $('#modalDiscountEmail')
    $modalDiscountEmail.find('#modal-discount-percentage').html(urlParams.get('pct_eml'))
    $modalDiscountEmail.modal('toggle')
  }

  // Setup referral tracking
  if (urlParams.has('friend')) {
    var friend = urlParams.get('friend')

    $('#modalReferralWelcome').modal("toggle")

    ga('set', 'campaignName', 'referral_program')
    ga('set', 'campaignKeyword', 'Referral Program')
    ga('set', 'campaignSource', friend)

    // Set the discount code to be the referral program discount code
    $.cookie('discount_code', 'friendofafriend', { path: '/' })
    $.cookie('referring_friend', friend, { path: '/' })
    Shopify.updateCartNote("Referring friend: " + friend, function () { })
  }

  if ($cartNoteTextarea.length && $.cookie('referring_friend')) {
    $cartNoteTextarea.val("Referring friend: " + $.cookie('referring_friend'))
  }

})
